module.exports = __webpack_public_path__ + "img/news_02.9c77911d.jpg";